// src/config/environment.js
const environments = {
  auth: {
    url: import.meta.env.VITE_AUTH_URL,
    path: import.meta.env.VITE_AUTH_PATH || "/auth",
  },
  sc_api: { url: import.meta.env.VITE_SC_API_URL },
  core_api: { url: import.meta.env.VITE_CORE_API_URL },
  geoflow: {
    handshake_url:
      import.meta.env.VITE_GEOFLOW_HANDSHAKE_URL ||
      "https://api.wetterwelt.de/geoflow/handshake",
    // Ersetzt die vom Handshake gelieferte GeoFlow-Base-URL — Dev-Vite-Proxy
    // bzw. /geoflow-proxy im Test-Gateway (CORS/Cookie-Workaround)
    base_override: import.meta.env.VITE_GEOFLOW_BASE_OVERRIDE || null,
    // GeoFlow-Tenant, dessen Szenen die Wetterkarte lädt (Demo: eigener Charter)
    charter: import.meta.env.VITE_GEOFLOW_CHARTER || "meteotracker",
  },
  change_feed: {
    // Build-Schalter für Stacks ohne Change-Feed (Demo): kein SSE-Connect, kein 503-Rauschen
    enabled: import.meta.env.VITE_CHANGE_FEED_ENABLED !== "false",
  },
};

export default environments;
